import React from 'react';
import { Route } from 'react-router-dom';

// import LoginRedirect from 'app/modules/login/login-redirect';
import Logout from 'app/modules/login/logout';
import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';
import PageNotFound from 'app/shared/error/page-not-found';
import EntryPage from 'app/full_page/entry/entry-page';

const EntryAppRoutes = () => {
  return (
    <div className="view-routes">
      <ErrorBoundaryRoutes>
        <Route index element={<EntryPage />} />
        <Route path="logout" element={<Logout />} />
        {/*<Route path="oauth2/authorization/oidc" element={<LoginRedirect/>}/>*/}
        <Route path="*" element={<PageNotFound />} />
      </ErrorBoundaryRoutes>
    </div>
  );
};

export default EntryAppRoutes;
